const overallRelations = [
    {
        //if two D’s: show this detail:
        head: `Direction`,
        body: `This pair exhibits a driven, goal-oriented team, usually with innovative ideas and
        strong leadership all around. Teams with low 'Direction' are referred to as 'Participatory'.`,
    },
    {
        //if two I’s: show this detail:
        head: `Communication`,
        body: `As the name suggests, it is found in teams that rely on strong
        communication and lean on positive personal relations for creative ideas to be born out of the flow of
        conversation. Where Communication is low in a team profile, it is referred to as applied.
        (Teams Low in I are ‘Applied’).`,
    },
    {
        //if two S’s: show this detail:
        head: `Stability`,
        body: `Stability describes a loyal and dependable team whose members prefer to avoid deliberate
        changes and tend to be good at reconciling conflicts swiftly. Teams without
        Stability are referred to as Flexible and, in contrast, will tend to go-with-the-flow. (Teams Low in S are Flexible)`,
    },
    {
        //if two C’s: show this detail:
        head: `Productivity`,
        body: `Teams whose members concentrate on
        procedure and quality – “the anchors of reality.” A team that will be almost too literal, but extremely
        conscientious and even-tempered, so arguments will be rare. Low Productivity results in an inverse factor
        known as Resourcefulness. (Teams Low in C are Resourceful)`,
    },
 
    //If S’s and I: show this detail:
    {
 
        head: `Steady`,
        body: `While this teams’ tempo will be different, they will find a similar focus and in favorable conditions, tends to be the ying to the yang.
        A complementary pairing whereby one talks, and the other listens; one calms the others storm. I-types tend to be energetic and bring innovative solutions and positive thinking to the room and can help encourage S-types to step outside of their comfort zone and pursue new opportunities. While S-types warm, dependable and offer a heavy hand of empathy.
        S-types can help I-types slow down and think through their ideas and actions.
        `,
    },
 
    //If C’s and I: show this detail:
    {
 
        head: `C and I`,
        body: `If they are not aware of their personalities, there will be difficulty forming a connection due to friction between them.
        The C-type will be in their head about what they need to do and following all the instructions needed while the I-type will have dived head first
        and hope to have a lengthy chat about the exciting project, which sinks the C-type further into their own hideaway`,
    },
    //If C’s and S: show this detail:
    {
 
        head: `C and S`,
        body: `A team that tends to get along smoothly; they both can recognize each other’s abilities as sharing some of their own
            traits and energy (introverted) and can therefore both calmly think twice before acting towards a decision.
            C + S Type decisions tend to be carefully planned out.`,
    },
 
    //If D and C, show this detail:
    {
 
        head: `D and C`,
        body: `A task-oriented team with the C-type more interested in the process (less interested in the result of it all) while the D-type will be excited about the execution.
        They will find themselves only chatting when needing an uplift or silly joke, only to put their heads down and devote themselves to the goal.
        The D-type is the gas pedal to the C-types brake pedal`,
    },
 
    //If D and I, show this detail:
    {
        head: `D and I`,
        body: `This group both wants to keep the ball rolling. D-types are usually assertive, pragmatic, and dedicated to their goal.
        They offer efficient decision-making and the first to offer leadership in any room. They can help I-types think more practically.
        I-types being more creative, can help D-types think outside-the-box and bring innovative ideas to the table.
        Both are verbal and outgoing, with slightly difference angles of interests. This team will be fast tempo and clear about
        their goals while doing their best to motivate those around them.
        I-types may come across too talkative for the always-on-the-ball D-type, but both will switch off when they see it best suited.`,
    },
 
    //If D and S, show this detail:
    {
        head: `D and S`,
        body: `If a task depends on effective cooperation, this may not be the most effective combination as issues could quickly arise.
        D-types will get started even before the instructions are given out while the passive S-type may begin to work on something the D has already done.
        The D-type will be critical and the S-type will think they are not being heard.
        Under favorable circumstances, this combo can work. A D-type likes giving orders and a S-type will be okay with receiving the order.
        D-types bring quick-thinking and efficiency to the room. They can help S-types make more objective decisions. While S-types are usually friendly, sincere,
        dependable, and they bring peace and empathetic-reasoning to an environment.
        They can help D-types consider how their actions affect others. `,
    }

]

const colors =[
    {//DD
    bg:'#ADACAC',
    text:'#FFFDFD'},
    //II
    {
        bg:'#D2D0D0',
        text:'#000000'},
    //SS
    { 
        bg:'#9D9D9D',
        text:'#000000'},
    //CC
    {
        bg:'#7D7C7C',
        text:'#FFFDFD'},
    //SI
    {
        bg:'#8F8D8D',
        text:'#FFFDFD'},
    //CI
    { 
        bg:'#C0BEBE',
        text:'#000000'},
    //CS
    {
        bg:'#767474',
        text:'#FFFDFD'},
    //DC
    { 
        bg:'#2A2929',
        text:'#FFFDFD'},
    //DI
    { 
        bg:'#605F5F',
        text:'#FFFDFD'},
    //DS
    {
        bg:'#DBD5D4',
        text:'#000000'},
]

export {overallRelations, colors}